export default {
  meta: {
    title: '工作台',
    url: '/abside', // 埋点字段，上报归属的模块
    urlName: 'ab侧', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
